import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    data: {
        requests_sent: [],
        requests_received: [],
        recommendation_received: [],
        recommendation_sent: []
    }
};
const slice = createSlice({
    initialState,
    name: "recommendationsData",
    reducers: {
        recommendationsDataStart: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        recommendationsDataSuccess: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            state.data = payload;
        },
        recommendationsDataFail: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        }
    }
});

const {reducer, actions} = slice;
export const {
    recommendationsDataFail, recommendationsDataStart, recommendationsDataSuccess
} = actions;
export default reducer;